// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const FactoryTourSection = registerClientReference(
    function() { throw new Error("Attempted to call FactoryTourSection() from the server but FactoryTourSection is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/FactoryTourSection/FactoryTourSection.tsx <module evaluation>",
    "FactoryTourSection",
);
export default registerClientReference(
    function() { throw new Error("Attempted to call the default export of [project]/src/components/FactoryTourSection/FactoryTourSection.tsx <module evaluation> from the server, but it's on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/FactoryTourSection/FactoryTourSection.tsx <module evaluation>",
    "default",
);
